export default __webpack_public_path__ + "media/images/features/yado/subtitle_sp-6d995c4f712d392b6f632fb519d59119.png";